export const defaultLocale = 'de-DE';

export const supportedLocales = ['de-DE'];
